export default __webpack_public_path__ + "static/meta-7fff945e53e1c45682a4c23370e482b8.png";